import { Box, Grid, styled, Typography } from "@mui/material";
import React from "react";
import { allImages } from "../../../assets";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1200px",
  margin: "auto",
  padding: "16px",

  "& .lpl_faq_gr": {
    fontWeight: 700,
    fontSize: "2.5rem",
    background: "linear-gradient(90deg, #EA580C 0%, #000000 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },

  // "& .lpl_mobile_img":{
  //     [theme.breakpoints.down("sm")]: {
  //       w: "2rem",
  //     },
}));

function VariantManage() {
  return (
    <MainView my={{ xs: 3, md: 6 }}>
      <Grid container spacing={2} alignItems={"center"}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h1"
            className="lpl_faq_gr"
            textAlign={{ md: "right" }}
          >
            Best Spa Management Site
          </Typography>
          <Typography
            variant="body1"
            fontSize={"1.125rem"}
            fontWeight={500}
            textAlign={{ md: "right" }}
            pl={{ md: 4 }}
            lineHeight={1.7}
          >
            Salon Management App is specially designed as a salon and spa
            management software. A salon booking management system offers you a
            wide variety of easy business operations with absolutely no limits.
            We provide you with a fully supported cloud-based salon software web
            interface app.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <img
            src={allImages.landingManageWebsite}
            alt="computer-screen"
            width="100%"
            height="100%"
            style={{ objectFit: "contain" }}
          />
        </Grid>
        <Grid item xs={12} md={5} display={"flex"} justifyContent={"center"}>
          <img
            src={allImages.landingManageMobile}
            alt="mobile-screen"
            width="70%"
            style={{ objectFit: "contain" }}
            className="lpl_mobile_img"
          />
        </Grid>
        <Grid item xs={12} md={7}>
          <Typography variant="h1" className="lpl_faq_gr">
            Booking ON Mobile Application
          </Typography>
          <Typography
            variant="body1"
            fontSize={"1.125rem"}
            fontWeight={500}
            lineHeight={1.7}
          >
            Salon Management App is specially designed as a salon and spa
            management software. A salon booking management system offers you a
            wide variety of easy business operations with absolutely no limits.
            We provide you with a fully supported cloud-based salon software web
            interface app.
          </Typography>
        </Grid>
      </Grid>
    </MainView>
  );
}

export default VariantManage;
